import { Form } from 'antd';
import { useContext } from 'react';

import { ExtraBed } from 'app/components/pages/Extranet/commons/ExtraBed/ExtraBed';
import { ViewEditModeContext } from 'app/context/ViewEditModeContext/ViewEditModeContext';
import { useBedCategories } from 'app/hooks/data/rooms/useBedCategories';
import type { Bed } from 'app/typings';
import { BABY_COT_BED_CATEGORY_ID, BED_TASK_CATEGORIES } from 'app/typings';

type AdditionalBedsProps = {
  addBed: ({ included }: { included: boolean }) => void;
  removeBed: (index: number) => void;
};

export const AdditionalBeds = ({ addBed, removeBed }: AdditionalBedsProps) => {
  const form = Form.useFormInstance<{ beds: Bed[] }>();
  const formValues = Form.useWatch([], form);
  const { data: bedCategories } = useBedCategories();
  const { mode } = useContext(ViewEditModeContext);

  if (!formValues?.beds) {
    return null;
  }

  return (
    <div className="additional-beds">
      <div className="bed-title-section">Additional beds</div>
      {BED_TASK_CATEGORIES.map(
        (bedTypeId, index) =>
          formValues.beds && (
            <ExtraBed
              key={'key' + index}
              listBed={formValues.beds}
              bed={formValues.beds.find((bed) => bed.categoryId === bedTypeId)}
              categoryName={
                bedTypeId === BABY_COT_BED_CATEGORY_ID
                  ? 'Baby cot'
                  : 'Folding guest bed'
              }
              categoryId={bedTypeId}
              add={addBed}
              remove={removeBed}
              previousPrefixes={['beds']}
              prefix={[
                formValues.beds.findIndex(
                  (bed) => bed.categoryId === bedTypeId
                ),
              ]}
              bedCategories={bedCategories}
              switchChecked={
                !!formValues.beds.find((bed) => bed.categoryId === bedTypeId)
              }
              mode={mode}
            />
          )
      )}
    </div>
  );
};
